<template>
  <div v-clickOutside="close">
    <div
      class="absolute cursor-default flex flex-col pt-8 text-app-color z-10 shadow-dropdown mt-8"
      :class="[isDarkMode ? 'bg-sidebar' : 'bg-white', classes, width]"
    >
      <p v-if="title" class="" :class="titleClasses">{{ title }}</p>

      <slot />

      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    title: { type: String },
    width: { type: String, default: 'w-180' },
    classes: {
      type: String,
      default: '-right-5 max-h-190 rounded-4'
    },

    titleClasses: {
      type: String,
      default: 'px-12 font-medium text-15 mb-6'
    }
  },

  emits: ['showDropdown'],

  setup (_, { emit }) {
    const { getters } = useStore()
    const isDarkMode = computed(() => getters.isDarkMode)

    function close () {
      emit('showDropdown', false)
    }

    return {
      // computed
      isDarkMode,
      // function
      close
    }
  }
})
</script>
